/** Status tones shared by StatusDot, Chip, StateBadge, Callout and metric tinting. */
export type Tone = 'ok' | 'warn' | 'info' | 'brand' | 'dim' | 'mute' | 'ink';

export const TONE_TEXT: Record<Tone, string> = {
  ok: 'text-ok',
  warn: 'text-warn',
  info: 'text-info',
  brand: 'text-brand-text',
  dim: 'text-dim',
  mute: 'text-mute',
  ink: 'text-ink',
};

export const TONE_BG: Record<Tone, string> = {
  ok: 'bg-ok',
  warn: 'bg-warn',
  info: 'bg-info',
  brand: 'bg-brand',
  dim: 'bg-dim',
  mute: 'bg-mute',
  ink: 'bg-ink',
};

/** Four-tier coverage threshold (DESIGN_SYSTEM section 9.2), applied to rings and bars alike. */
export function thresholdTone(value: number): Exclude<Tone, 'dim' | 'mute' | 'ink'> {
  if (value > 0.9) return 'ok';
  if (value > 0.75) return 'info';
  if (value > 0.6) return 'warn';
  return 'brand';
}

export const THRESHOLD_STROKE: Record<'ok' | 'info' | 'warn' | 'brand', string> = {
  ok: 'var(--ok)',
  info: 'var(--info)',
  warn: 'var(--warn)',
  brand: 'var(--brand)',
};
